export default "__VITE_ASSET__Zc7RwzFq__"